import { adminCopy } from "../copy/admin";

export type ConsoleTab = "users" | "terms" | "reads" | "reports" | "settings";
export type SettingsTab = "password" | "email";

export type ConsoleTabDefinition = {
  id: string;
  label: string;
};

export function consoleShellMarkup(tabs: ConsoleTabDefinition[], activeTab: ConsoleTab | SettingsTab, trailingAction = ""): string {
  return `
    <section class="console-screen">
      <div class="console-tab-list" role="tablist" aria-label="Console sections">
        ${tabs.map((tab) => `<button type="button" class="console-tab ${tab.id === activeTab ? "active" : ""}" data-console-tab="${tab.id}" role="tab" aria-selected="${String(tab.id === activeTab)}">${tab.label}</button>`).join("")}
        ${trailingAction}
      </div>
      <div id="consolePanel" class="console-panel" role="tabpanel"></div>
    </section>
  `;
}

export function subTabMarkup(tabs: ConsoleTabDefinition[], activeTab: string, badge?: Record<string, number>): string {
  return `
    <div class="console-subtabs" role="tablist">
      ${tabs.map((tab) => `
        <button type="button" class="console-subtab ${tab.id === activeTab ? "active" : ""}" data-console-subtab="${tab.id}" role="tab" aria-selected="${String(tab.id === activeTab)}">
          ${tab.label}${badge?.[tab.id] ? `<span class="console-count">${badge[tab.id]}</span>` : ""}
        </button>
      `).join("")}
    </div>
  `;
}

export function panelMarkup(explainer: string, content: string): string {
  return `
    <p class="console-explainer">${explainer}</p>
    <div class="console-panel-scroll">${content}</div>
  `;
}

export function bindConsoleTabs(onSelect: (tab: string) => void): void {
  document.querySelectorAll<HTMLButtonElement>("[data-console-tab]").forEach((button) => {
    button.addEventListener("click", () => onSelect(button.dataset.consoleTab || ""));
  });
}

export function bindSubTabs(onSelect: (tab: string) => void): void {
  document.querySelectorAll<HTMLButtonElement>("[data-console-subtab]").forEach((button) => {
    button.addEventListener("click", () => onSelect(button.dataset.consoleSubtab || ""));
  });
}

export const adminConsoleTabs: ConsoleTabDefinition[] = [
  { id: "users", label: adminCopy.console.usersTab },
  { id: "terms", label: adminCopy.console.termsTab },
  { id: "reads", label: adminCopy.console.readsTab },
  { id: "reports", label: adminCopy.console.reportsTab },
  { id: "settings", label: adminCopy.console.settingsTab }
];

export const settingsConsoleTabs: ConsoleTabDefinition[] = [
  { id: "password", label: adminCopy.console.passwordTab },
  { id: "email", label: adminCopy.console.emailTab }
];
